/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Get_Api_KeyInputs */

const en_console_get_api_key = /** @type {(inputs: Console_Get_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get an API key`)
};

const zh_hans1_console_get_api_key = /** @type {(inputs: Console_Get_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取 API 密钥`)
};

const pt_br2_console_get_api_key = /** @type {(inputs: Console_Get_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obter chave de API`)
};

const es_console_get_api_key = /** @type {(inputs: Console_Get_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén una clave de API`)
};

const fr_console_get_api_key = /** @type {(inputs: Console_Get_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir une clé API`)
};

const de_console_get_api_key = /** @type {(inputs: Console_Get_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel holen`)
};

const ru_console_get_api_key = /** @type {(inputs: Console_Get_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить API-ключ`)
};

const it_console_get_api_key = /** @type {(inputs: Console_Get_Api_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni una chiave API`)
};

/**
* | output |
* | --- |
* | "Get an API key" |
*
* @param {Console_Get_Api_KeyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_get_api_key = /** @type {((inputs?: Console_Get_Api_KeyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Get_Api_KeyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_get_api_key(inputs)
	if (locale === "pt-BR") return pt_br2_console_get_api_key(inputs)
	if (locale === "es") return es_console_get_api_key(inputs)
	if (locale === "fr") return fr_console_get_api_key(inputs)
	if (locale === "de") return de_console_get_api_key(inputs)
	if (locale === "ru") return ru_console_get_api_key(inputs)
	if (locale === "it") return it_console_get_api_key(inputs)
	return en_console_get_api_key(inputs)
});